import React from 'react';
import { DatabaseIcon, BrainIcon, KeyIcon, ShieldCheckIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { useNavigate } from 'react-router-dom';
export function IntegrationsPage() {
  const navigate = useNavigate();
  const categories = [{
    title: 'AI Platforms & Frameworks',
    icon: <BrainIcon className="h-6 w-6 text-[#4db8a4]" data-id="element-247" />,
    items: ['LangChain', 'LlamaIndex', 'OpenAI Assistants', 'Anthropic Claude', 'AutoGen']
  }, {
    title: 'Identity Providers (IdP)',
    icon: <KeyIcon className="h-6 w-6 text-[#4db8a4]" data-id="element-248" />,
    items: ['Okta', 'Microsoft Entra ID', 'Auth0', 'Ping Identity', 'Custom OIDC']
  }, {
    title: 'Data Sources & SaaS',
    icon: <DatabaseIcon className="h-6 w-6 text-[#4db8a4]" data-id="element-249" />,
    items: ['Snowflake', 'PostgreSQL', 'Salesforce', 'Jira', 'Confluence', 'GitHub']
  }, {
    title: 'Compliance & SIEM',
    icon: <ShieldCheckIcon className="h-6 w-6 text-[#4db8a4]" data-id="element-250" />,
    items: ['Splunk', 'Datadog', 'AWS CloudTrail', 'Vanta', 'Drata']
  }];
  return <div className="w-full max-w-5xl mx-auto py-12 px-4 animate-in fade-in duration-500" data-id="element-251">
      <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-252">
        <h1 className="text-4xl font-bold text-[#1e3a5f] mb-6" data-id="element-253">
          Integrates with your existing stack
        </h1>
        <p className="text-xl text-gray-600 leading-relaxed" data-id="element-254">
          MCPGuard sits seamlessly between your AI agents, identity providers,
          and data stores to enforce policy without requiring a massive
          architectural rewrite.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-255">
        {categories.map((category, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm" data-id="element-256">
            <div className="flex items-center gap-4 mb-6" data-id="element-257">
              <div className="h-12 w-12 bg-[#4db8a4]/10 rounded-lg flex items-center justify-center" data-id="element-258">
                {category.icon}
              </div>
              <h2 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-259">
                {category.title}
              </h2>
            </div>
            <ul className="space-y-3" data-id="element-260">
              {category.items.map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-261">
                  <div className="h-1.5 w-1.5 rounded-full bg-[#4db8a4]" data-id="element-262" />
                  <span className="text-lg" data-id="element-263">{item}</span>
                </li>)}
            </ul>
          </div>)}
      </div>

      <div className="bg-[#e8f7f4] rounded-xl p-8 text-center border border-[#4db8a4]/30" data-id="element-264">
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4" data-id="element-265">
          Don't see your tool?
        </h2>
        <p className="text-lg text-[#3a5878] mb-6 max-w-2xl mx-auto" data-id="element-266">
          MCPGuard is built on open standards and supports custom integrations
          via our API and webhook system.
        </p>
        <Button onClick={() => navigate('/early-access')} data-id="element-267">
          Contact us about custom integrations
        </Button>
      </div>
    </div>;
}